// extracted by mini-css-extract-plugin
export default {"root":"Link_root__xdbfl","icon":"Link_icon__g+5ni","disabled":"Link_disabled__UYpZC"};